import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M4 12a8 8 0 1 0 16 0a8 8 0 1 0 -16 0","key":"svg-1"}],["path",{"d":"M12 2l0 2","key":"svg-2"}],["path",{"d":"M12 20l0 2","key":"svg-3"}],["path",{"d":"M20 12l2 0","key":"svg-4"}],["path",{"d":"M2 12l2 0","key":"svg-5"}]]

const IconCurrentLocation = createReactComponent('outline', 'current-location', 'CurrentLocation', __iconNode);

export default IconCurrentLocation;